<template>
    <v-app>
        <v-main>
            <div class="fill-height">
                <router-view />
            </div>
        </v-main>

        <v-snackbar
            v-model="snackbar.isOpened"
            :timeout="snackbar.closable ? -1 : 5000"
            bottom
            :color="snackbar.color">
            {{ snackbar.text }}

            <span
                v-if="snackbar.subtext"
                class="d-block text-small text-center">
                {{ snackbar.subtext }}
            </span>

            <v-btn
                v-if="snackbar.closable"
                slot="action"
                icon
                @click="closeSnackbar">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
export default {
    computed: {
        snackbar() {
            return this.$store.state.snackbar;
        },
    },

    methods: {
        closeSnackbar() {
            this.$store.commit('closeSnackbar');
        },
    },
};
</script>